<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">订单列表</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-tabs v-model="query.status" type="card" @tab-click="submitQuery(1)">
        <el-tab-pane v-for="(item) in orderStatuses" :key="item.name" :name="item.name">
            <span slot="label">
        <span>{{ item.label }}</span>
      </span>
        </el-tab-pane>
      </el-tabs>
      <el-form :inline="true" :model="query" class="demo-form-inline" size="small">
        <el-form-item label="下单日期">
          <el-date-picker
              style="width: 220px"
              @change="dateRangeChangFun"
              v-model="dateRange"
              type="daterange"
              align="right"
              value-format="yyyy-MM-dd"
              range-separator="："
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单类型">
          <el-select v-model="query.feeType" clearable>
            <el-option v-for="(item, index) in feeTypes" :key="index" :label="item.label" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键字">
          <el-input v-model="query.keyword" placeholder="买家名称/备注、订单编码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitQuery(1)">搜索</el-button>
          <el-button type="primary" size="small" @click="exportOrder">导出</el-button>
        </el-form-item>
      </el-form>
      <hr/>
    </div>
    <el-table border :data="orderSellers" highlight-current-row>
      <el-table-column align="center" type="index"/>
      <el-table-column label="购买用户" align="center">
        <template slot-scope="scope">
          <p>
            <el-image style="height: 45px; width: 45px; border-radius: 75px;border: rgb(241,242,244) solid 1px;"
                      :src="scope.row.iconPath">
              <div slot="error" class="image-slot">
                <el-image title="加载失败"
                          src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/qunyiguan/c6d05d1e8c33703186ec1f89743f979.png"/>
              </div>
            </el-image>
          </p>
          <p>昵称：{{ scope.row.buyerUserName || '已失效' }}</p>
        </template>
      </el-table-column>
      <el-table-column label="订单编号" align="center" prop="code"/>
      <el-table-column label="下单时间" align="center" prop="createTime"/>
      <el-table-column label="订单金额" width="180px" align="center">
        <template slot-scope="scope">
          ￥{{ scope.row.orderFee }}
        </template>
      </el-table-column>
      <el-table-column label="优惠金额" width="180px" align="center">
        <template slot-scope="scope">
          {{ scope.row.freeFee ? '-￥' + scope.row.freeFee : '无优惠' }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态" width="180px" align="center">
        <template slot-scope="scope">
                            <span v-if="'TEAM'===scope.row.feeType">
                                <p>订单状态：{{ orderStatusMap[scope.row.status] }}</p>
                                <p>团购状态：{{ teamBuyStatusMap[scope.row.teamBuyStatus] }}</p>
                            </span>
          <span v-else>
                                <p>{{ orderStatusMap[scope.row.status] }}</p>
                            </span>
        </template>
      </el-table-column>
      <el-table-column label="订单类型" width="180px" align="center">
        <template slot-scope="scope">
          {{ scope.row.feeTypeLabel }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="250px">
        <template slot-scope="scope">
          <p>
            <el-tooltip content="订单详情" placement="top"
                        effect="light">
              <el-button type="primary"
                         @click="openOrderDetail(scope.row)"
                         size="mini"
                         icon="el-icon-s-order" round>
                详情
              </el-button>
            </el-tooltip>
            <el-tooltip content="删除订单" placement="top"
                        effect="light">
              <el-button type="danger"
                         :disabled="!('ORDERD'===scope.row.status || 'CANCEL'===scope.row.status)"
                         @click="saveOrderClientShowStatus(scope.row.orderId)"
                         size="mini"
                         icon="el-icon-document-delete" round>
                删除
              </el-button>
            </el-tooltip>
          </p>
          <p>
            <el-tooltip content="售后处理" placement="top"
                        effect="light">
              <el-button type="success"
                         :disabled="!('SERVICE_APPLY'===scope.row.status)"
                         @click="orderServiceClickFun(scope.row.orderId)"
                         size="mini"
                         icon="el-icon-service" round>
                售后
              </el-button>
            </el-tooltip>
            <el-tooltip content="收货" placement="top"
                        effect="light">
              <el-button type="warning"
                         :disabled="!('SENDED'===scope.row.status)"
                         @click="orderReceive(scope.row.orderId)"
                         size="mini"
                         icon="el-icon-receiving" round>
                收货
              </el-button>
            </el-tooltip>
          </p>
        </template>
      </el-table-column>
    </el-table>
    <order-return ref="order-return" :success="submitQuery"></order-return>
    <order-detail ref="order-detail"></order-detail>
    <vue-pager v-bind:datafile="fillData" v-bind:request-before="requestBefore" url="order/pageOrderByAdmin" v-bind:query="query"
               ref="pager" v-bind:init="true"/>
  </div>
</template>
<script>
import OrderReturn from '@/views/order/components/order-return.vue';
import orderDetail from '@/views/order/components/order-detail.vue';

export default {
  data() {
    return {
      totalDataSize: 0,
      orderSellers: [],
      feeTypes:[],
      query: {
        status: '',
        feeType:'',
      },
      dateRange: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '当天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近30天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      feeTypeMap: {},
      orderStatuses: [],
      orderStatusMap: {},
      dynamicPath: config.dynamicResourcePath,
      address: {},
      teamBuyStatusMap: {}
    }
  },
  components: {
    OrderReturn,
    orderDetail
  },
  created() {
    var _this = this;
    _this.query.status = _this.$route.query.status;
    _this.query.userId = _this.$route.query.userId
    _this.query.feeType = _this.$route.query.feeType
    var _orderStatuses = _this.$common.enum_config('EOrderStatus');
    if (_orderStatuses) {
      _orderStatuses.forEach((item) => {
        _this.orderStatusMap[item.name] = item.label;
      });
    }
    _this.orderStatuses = _orderStatuses;
    if (_this.orderStatuses) {
      _this.orderStatuses.splice(0, 0, {name: '', label: '全部'});
    }
    _this.feeTypes = _this.$common.enum_config('EOrderFeeType');
    if (_this.feeTypes) {
      _this.feeTypes.forEach((item) => {
        _this.feeTypeMap[item.name] = item.label;
      });
    }
    var teamBuyStatus = _this.$common.enum_config('ETeamBuyStatus');
    if (teamBuyStatus) {
      teamBuyStatus.forEach((item) => {
        _this.teamBuyStatusMap[item.name] = item.label;
      });
    }
  },
  methods: {
    orderReceive(_orderId){
      var _this = this;
      _this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.my_ajax({
          url: '/order/orderReceive',
          data: {
            orderId: _orderId,
          },
          success: function (response) {
            _this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.submitQuery(_this.query.current);
              }
            });
          }
        });
      }).catch((e) => {
        console.log(e);
      });
    },
    requestBefore() {
      var _this = this;
      if (_this.query && (_this.query.status === 0 || _this.query.status === "0")) {
         _this.query.status = ''
      }
    },
    openOrderDetail(_row) {
      this.$refs["order-detail"].open(_row);
    },
    saveOrderClientShowStatus(_orderSellerId) {
      var _this = this;
      _this.$confirm('确认该操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$common.my_ajax({
          url: '/order/deleteOrder',
          data: {
            orderId: _orderSellerId,
          },
          success: function (response) {
            _this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
              onClose: function () {
                _this.submitQuery(_this.query.current);
              }
            });
          }
        });
      }).catch((e) => {
        console.log(e);
      });
    },
    fillData(_response) {
      this.totalDataSize = this.$refs.pager.total
      this.orderSellers = _response.items || [];
    },
    submitQuery(_num) {
      var _this = this;
      _this.orderSellers = [];
      _this.$refs.pager.gotoPage(_num);
    },
    dateRangeChangFun(e) {
      this.$set(this.query, 'startTime', e[0]);
      this.$set(this.query, 'endTime', e[1]);
    },
    exportOrder() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'orderSeller/exportByManager',
        data: _this.query,
        success: function (response) {
          var filePath = response.item;
          window.location.href = _this.dynamicPath + filePath;
        }
      });
    },

    //售后
    orderServiceClickFun(_orderId) {
      this.$refs['order-return'].openDialog(_orderId);
    },
  },
  watch: {}
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 0 !important;
}
</style>
